import { urlHasProtocol, urlRegex } from './url-regex'

export const linkifyHtml = (text: string): string => {
  return (
    text?.replace(urlRegex(), (match) => {
      const hasUrlProtocol = urlHasProtocol(match)
      const href = `${hasUrlProtocol ? match : `https://${match}`}`

      return `<a href="${href}" target="_blank" class="linkified">${match}</a>`
    }) ?? text
  )
}
